import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import {
  EventoLimiteCredito,
  EventoLimiteCreditoResult
} from '@app/modules/clientes/model/cliente.model';
import { Observable } from 'rxjs';
import {
  DeepPartial,
  PaginationOptions
} from '../../../shared/components/search-header/models/entity-params';
import { IParcelasPagar } from '../../contas-pagar/models/parcelas.model';
import { IFornecedor } from '../models/fornecedor.model';

@Injectable()
export class FornecedorService extends EntityService<IFornecedor> {
  constructor(protected configService: ConfigService) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'fornecedor',
      pluralBaseEntityEndPoint: 'fornecedores'
    });
  }

  /**
   * Associa varios produtos a um fornecedor para serem usados na entrada fiscal
   * @param produto_fornecedores
   * @param fornecedor_id
   * @returns
   */
  associarProdutos(produto_fornecedores: any[], fornecedor_id: string) {
    const url = `${this.baseURL}/${fornecedor_id}/vincular_produtos`;
    return this.http.put<{ produto_fornecedores: any[] }>(
      url,
      { produto_fornecedores: produto_fornecedores },
      {
        headers: this.getHeader()
      }
    );
  }

  /**
   * Responsável por enviar um evento de atualização do limite de credito
   * @param fornecedor_id
   * @param evento
   * @returns
   */
  atualizarLimiteDeCredito(fornecedor_id: string, evento: EventoLimiteCredito) {
    const url = `${this.baseURL}/${fornecedor_id}/reg_fornecedor_limite_credito_evento`;
    return this.http.put<{ evento: EventoLimiteCreditoResult }>(url, evento, {
      headers: this.getHeader()
    });
  }

  /**
   * Pega todas as parcelas em aberto de um cliente
   * @param fornecedor_id
   * @param include
   * @param pagination
   * @param where
   * @param order_by
   * @returns
   */
  public pegarParcelasAbertas(
    fornecedor_id: string,
    include?: string[],
    pagination?: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    where?: DeepPartial<IParcelasPagar>,
    order_by?: string
  ): Observable<any> {
    const url = `${this.baseURL}/${fornecedor_id}/conta_pagar_parcelas`;
    let params = new HttpParams();

    if (include) {
      params = params.append('include', include.join(','));
    }
    if (pagination) {
      params = params
        .append('require_pagination', pagination.require_pagination)
        .append('page_size', pagination.page_size)
        .append('page', pagination.page);
    }

    if (where) {
      params = params.append(`${Object.keys(where)[0]}`, where.status);
    }

    if (order_by) {
      params = params.append('order_by', order_by);
    }

    return this.http.get<{
      fornecedor: { conta_pagar_parcelas: IParcelasPagar[] };
      pagination: PaginationOptions;
    }>(url, { headers: this.getHeader(), params });
  }
}
